/* eslint-disable array-callback-return */
import convertSize from 'convert-size';
import { ChangeEvent, useState } from 'react';
import { FiPlusSquare, FiUpload } from 'react-icons/fi';
import { CardHeader, Form, Input } from 'reactstrap';
import { Btn } from '../../../../AbstractElements';
import { filesData } from '../../../../Data/Application/FileSideBar/FileSideBar';
import { AddNew, Upload } from '../../../../utils/Constant';
import msToTime from '../../../../utils/helper/msToTime';
import FileContentBody from './FileContentBody';
import SearchBar from './SearchBar';

const FileContent = () => {
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [myFile, setMyFile] = useState(filesData);
    const fileList = myFile.filter((data) => {
      if (searchTerm == null) return data;
      if (data.title.toLowerCase().includes(searchTerm.toLowerCase())) {
        return data;
      }
    });
    const getFile = () => {
      document.getElementById('upfile')?.click();
    };
    const onFileChange = (event: ChangeEvent<HTMLInputElement>) => {
      const files = event.target.files;
      if (files && files.length > 0) {
        setSelectedFile(files[0]);
      }
    };
    const onFileUpload = () => {
      const date = new Date();
      const time = msToTime(date.getMilliseconds(), 'ago', 'long');
      let myFiles = [...myFile];
      if (selectedFile !== null) {
        myFiles.push({
          icons:"file-excel-o",
          title: `${selectedFile.name}`,
          details: `${time} ${Number.parseFloat(convertSize(selectedFile.size)).toFixed(2)} KB`,
          color:"success"
        });
        setMyFile(myFiles);
      }
    };
    return (
      <>
        <CardHeader className='card-no-border pb-0'>
          <div className='d-md-flex d-sm-block gy-3 text-sm-center'>
            <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
            <div className='flex-grow-1 d-flex align-items-center justify-content-md-end justify-content-center'>
              <Form>
                <Btn color='primary' className='d-flex align-items-center' onClick={getFile}>
                  <FiPlusSquare className='me-1'/> {AddNew}
                </Btn>
                <div className='file-data'>
                  <Input id='upfile' multiple type='file' onChange={(e) => onFileChange(e)} />
                </div>
              </Form>
              <Btn outline color='primary' className='ms-2' onClick={onFileUpload}>
                <FiUpload className='me-1' />
                {Upload}
              </Btn>
            </div>
          </div>
        </CardHeader>
        <FileContentBody myFile={fileList} />
      </>
    )
}

export default FileContent